import {
  FETCH_HISTORY,
  FETCH_HISTORY_FAIL,
  FETCH_HISTORY_SUCCESS
} from '../../actions/cm/caseHistory';

export const initialState = {
  isLoading: false,
  hasError: false,
  historyItems: [],
  historyItemsTotal: 0
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_HISTORY:
      return {
        ...state,
        isLoading: true
      };
    case FETCH_HISTORY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasError: false,
        historyItems: payload.list,
        historyItemsTotal: payload.total
      };
    case FETCH_HISTORY_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        historyItems: [],
        historyItemsTotal: 0
      };
    default:
      return state;
  }
}
